export function shortOid(oid: string): string {
  return oid.slice(0, 7)
}
